import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

export type ExportSelectionType = 'all-rows' | 'selected-rows';
export type ExportFormat = 'xml' | 'csv' | 'tsv';
export type ExportType = 'application/xml' | 'text/plain';

export interface ExportRowsEvent {
  readonly selectionType: ExportSelectionType;
  readonly format: ExportFormat;
  readonly type: ExportType;
}

@Component({
  selector: 'asax-result-table-export-container',
  templateUrl: './export-container.component.html',
  styles:
  [
    `.dropdown-toggle::after {
      display: none;
    }`
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportContainerComponent implements OnChanges {
  @Input() selectedRowsIds: string[];
  @Input() isExportFileBeingGenerated: boolean;

  @Output() outExportRows = new EventEmitter<ExportRowsEvent>();

  exportSelectionType: ExportSelectionType = 'all-rows';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRowsIds) {
      if (!this.selectedRowsIds?.length) {
        this.exportSelectionType = 'all-rows';
      }
    }
  }

  setExportSelectionType(exportSelectionType: ExportSelectionType): void {
    if (exportSelectionType === 'selected-rows' && !this.selectedRowsIds?.length) {
      this.exportSelectionType = 'all-rows';
    } else {
      this.exportSelectionType = exportSelectionType;
    }
  }

  emitExportRows(format: ExportFormat, type: ExportType): void {
    this.outExportRows.emit({selectionType: this.exportSelectionType, format, type});
  }
}
